import {CountUp} from "countup.js";

window.addEventListener('load', () => {
    const countupElements = Array.from(document.querySelectorAll<HTMLElement>("[data-countup-value]"));
    function extract_prefix_suffix(input: string): { prefix: string; value: number; suffix: string } {
        const match = input.match(/^([^0-9.-]*)([0-9.-]+)([^0-9.-]*)$/);

        if (!match) {
            return { prefix: "", value: NaN, suffix: "" };
        }

        const [, prefix, valueStr, suffix] = match;

        return {
            prefix: prefix || "",
            value: parseFloat(valueStr),
            suffix: suffix || "",
        };
    }


    for(const countupElement of countupElements) {
        const value = countupElement.dataset.countupValue;
        const parsed_value = extract_prefix_suffix(value || "0");


        let instance = new CountUp(countupElement, parsed_value.value, {
            prefix: parsed_value.prefix,
            suffix: parsed_value.suffix,
            duration: 1,
            enableScrollSpy: true,
            scrollSpyOnce: true,
        });
    }
});
